const elements = {
  imagem: {
    id: "imagem",
    name: "Imagem",
    type: "file",
    apiUrl: 'winePhotos',
    required: true,
  },

  nome: {
    id: "nome",
    name: "Nome",
    type: "text",
    maxLength: 30,
    apiUrl: '',
    required: true,
  },
  tipo: {
    id: "tipo",
    name: "Tipo",
    type: "option",
    apiUrl: 'wineTypes',
    required: true,
  },
  casta: {
    id: "casta",
    name: "Casta",
    type: "option",
    apiUrl: 'wineVarieties',
    required: true,
  },
  pontuacao: {
    id: "pontuacao",
    name: "Pontuação",
    type: "number",
    step: 0.01,
    apiUrl: '',
    required: true,
  },
  produtor: {
    id: "produtor",
    name: "Produtor",
    type: "option",
    maxLength: 30,
    apiUrl: 'producers',
    required: true,
  },
  regiao: {
    id: "regiao",
    name: "Região",
    type: "option",
    maxLength: 30,
    apiUrl: 'regions',
    required: true,
  },
  quinta: {
    id: "quinta",
    name: "Quinta",
    type: "option",
    maxLength: 30,
    apiUrl: 'wineFarms',
    required: true,
  },
  formato: {
    id: "formato",
    name: "Formato",
    type: "option",
    apiUrl: 'bottleCapacities',
    required: true,
  },
  anoColheita: {
    id: "anoColheita",
    name: "Ano de Colheita",
    type: "option",
    maxLength: 30,
    apiUrl: 'grapeHarvestYears',
    required: true,
  },
  // engarrafamento: {
  //   id: "engarrafamento",
  //   name: "Engarrafamento",
  //   type: "option",
  //   maxLength: '',
  //   apiUrl: ''

  // },
  enologo: {
    id: "enologo",
    name: "Enólogo",
    type: "option",
    maxLength: '',
    apiUrl: 'wineMakers',
    required: true,
  },
  preco: {
    id: "preco",
    name: "Preço",
    type: "number",
    step: 0.01,
    apiUrl: '',
    required: true,
  },
  localCompra: {
    id: "localCompra",
    name: "Local da Compra",
    type: "input",
    apiUrl: '',
    required: true,
  },
  dataCompra: {
    id: "dataCompra",
    name: "Data da Compra",
    type: "date",
    apiUrl: '',
    required: true,
  },
  quantidade: {
    id: "quantidade",
    name: "Quantidade",
    type: "number",
    step: 1,
    apiUrl: '',
    required: true,
  },
  estado: {
    id: "estado",
    name: "Estado",
    type: "option",
    apiUrl: 'wineStates',
    required: true,
  },
  garrafeira: {
    id: "garrafeira",
    name: "Garrafeira",
    type: "option",
    apiUrl: 'wineCellars',
    required: true,
  },
  secao: {
    id: "secao",
    name: "Seção",
    type: "option",
    apiUrl: 'wineCellarSections',
    required: true,
  },
  notasProva: {
    id: "notasProva",
    name: "Notas de Prova",
    type: "text",
    apiUrl: 'wineTastingNotes',
    required: true,
  },
  prontoParaBeber: {
    id: "prontoParaBeber",
    name: "Pronto Para Beber",
    type: "date",
    apiUrl: '',
    required: true,
  },
}



export default elements
